import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminDashboardResponse } from '@utils/types/admin';

/**
 * Hook to fetch on-prem admin dashboard data
 *
 * GET /api/admin/on-prem/dashboard
 *
 * Returns system health, queue depth, active sessions, storage usage, etc.
 */
export const useGetAdminDashboard = (options?: {
  refetchInterval?: number;
}) => {
  const fetchDashboard = async () => {
    const url = `api/admin/on-prem/dashboard`;
    const response = await Axios.get<AdminDashboardResponse>(url);
    return response.data;
  };

  return useQuery<AdminDashboardResponse, AxiosError<BaseError>>(
    ['adminDashboard'],
    fetchDashboard,
    {
      useErrorBoundary: false,
      refetchInterval: options?.refetchInterval ?? 30000, // Default 30s auto-refresh
      staleTime: 10000 // Consider data stale after 10 seconds
    }
  );
};
